import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitMode"]
  connect() {
    this.forceSaveHandler = (event) => this.forceSave(event)
    window.addEventListener("force-save", this.forceSaveHandler)
  }

  disconnect() {
    window.removeEventListener("force-save", this.forceSaveHandler)
  }

  forceSave(event) {
    const submitMode = event.detail?.submitMode
    if (submitMode && this.hasSubmitModeTarget) {
      this.submitModeTarget.value = submitMode
    }

    this.element.requestSubmit()
  }
}
